import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        login(data.token, data.user);
        if (data.user.role === "pending") { navigate("/choose-role", { replace: true }); return; }
        toast.success(`Welcome, ${data.user.name.split(" ")[0]}!`);
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      })
      .catch((err) => {
        toast.error(formatError(err.response?.data?.detail));
        navigate("/login", { replace: true });
      });
  }, [login, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center text-lg text-slate-700">
      Signing you in with Google…
    </div>
  );
}
